namespace GeniuzPOS.Inventory {
    export class IcStkAdjCodeColumns {
        static columnsKey = 'Inventory.IcStkAdjCode';
    }
}
